import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import MeetingsAdminApp from 'meetings-admin-app'


import {mainTheme} from "themes";
import ErrorCatcher from "error-catcher";
console.log('GreetingsList-page');
ReactDOM.render(<MeetingsAdminApp theme={mainTheme}/>,
    document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
